import { useEffect, useMemo, useState } from 'react';
import shallow from 'zustand/shallow';

import useShareTradeModal from 'features/sharetrade/stores/useShareTradeModal';

import {
  trackDoneSelected,
  trackOrderViewed,
  trackShareSelected,
  trackTradeSharedViewed,
} from 'features/sharetrade/analytics/shareTradeShareTracker';
import tradingModalStore from 'global/TradingModal/store';
import ModalShareTrade from '../ModalShareTrade';
import ModalSuccessInfo from '../ModalSuccessInfo';

const ModalShareTradeManager = () => {
  const [isSuccessVisible, setIsSucessVisible] = useState(false);

  const [isVisible, setIsVisible] = useShareTradeModal(
    (s) => [s.isVisible, s.setIsVisible],
    shallow,
  );

  const symbol = tradingModalStore((s) => s.symbol);

  const isShareTradeVisible = useMemo(
    () => isVisible && !isSuccessVisible,
    [isVisible, isSuccessVisible],
  );

  const handleShareTradeCancel = () => {
    setIsVisible(false);
  };

  const handleShareTradeSubmit = async (isAddAutoShare: boolean) => {
    setIsSucessVisible(true);
    trackShareSelected(symbol, isAddAutoShare);
  };

  const handleSuccessInfoConfirm = () => {
    setIsVisible(false);
    setIsSucessVisible(false);
    trackDoneSelected(symbol);
  };

  useEffect(() => {
    if (isShareTradeVisible) trackOrderViewed();
  }, [isShareTradeVisible]);

  useEffect(() => {
    if (isSuccessVisible) trackTradeSharedViewed();
  }, [isSuccessVisible]);

  return (
    <>
      <ModalSuccessInfo
        visible={isSuccessVisible}
        onCancel={handleSuccessInfoConfirm}
        onConfirm={handleSuccessInfoConfirm}
      />
      <ModalShareTrade
        visible={isShareTradeVisible}
        onCancel={handleShareTradeCancel}
        onShareSubmit={handleShareTradeSubmit}
        zIndex={1003}
      />
    </>
  );
};

export default ModalShareTradeManager;
